import { FC } from 'react';
import Image from 'next/image';
import { Container } from './HeartButton.style';
interface Props {
  isLike: boolean;
  onUpdateLikeState: () => void;
}
const HeartButton: FC<Props> = ({
  isLike,
  onUpdateLikeState
}: Props) => {
  const handleOnClick = () => {
    onUpdateLikeState();
  };
  return <Container onClick={handleOnClick} $isLike={isLike}>
            <Image src={isLike ? '/icons/heart-button/white-heart-button.svg' : '/icons/heart-button/grey-heart-button.svg'} alt="heart-icon" height={24} width={24} />
        </Container>;
};
export default HeartButton;